module.exports = {
  "zones": {
    "Pacific/Fiji": ["z", {
      "wallclock": -1709942400000,
      "format": "+12/+13",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": -1709985344000,
      "save": 0,
      "rules": "Fiji"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 42944000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Fiji": [{
      "from": 2014,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2015,
      "to": 1.7976931348623157e+308,
      "month": 0,
      "day": [0, 13],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2014,
      "to": 2014,
      "month": 0,
      "day": [0, 18],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2010,
      "to": 2013,
      "month": 9,
      "day": [0, 21],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2012,
      "to": 2013,
      "month": 0,
      "day": [0, 18],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2011,
      "to": 2011,
      "month": 2,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2010,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2009,
      "to": 2009,
      "month": 10,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1999,
      "to": 2000,
      "month": 1,
      "day": [0, -29],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1998,
      "to": 1999,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};